import styled from 'styled-components';

const YadoItemPhotoView = styled.div`
  flex: 0 1 auto;
  margin: 0;
  padding: 0;
  border-radius: 4px;
  .photo-container {
    margin: 0;
    width: 240px;
    height: 100%;
    .no-image {
      height: 100%!important;
      min-height: 200px;
      display: flex!important;
      align-items: center;
      justify-content: center;
      color: var(--gray600);
    }
    .photo-big, .no-image {
      height: 100%!important; /* TODO: .photo-smallを表示したら削除 */
      min-height: 200px; /* TODO: .photo-smallを表示したら削除 */
      position: relative;
      width: 100%;
      margin-left: -50%;
      margin-right: -50%;
      left: 50%;
      right: 50%;
      width: 240px;
      height: 174px;
      display: block;
      overflow: hidden;
      margin-bottom: 1px;
      cursor: pointer;
      background-color: var(--gray200);
    }
    img {
      width: 100%;
      text-align: center;
      height: auto;
      background-position: 50% 50%;
      background-size: cover;
      position: relative;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    ul {
      margin: 0;
      padding: 0;
      font-size: 0;
      display: flex;
      list-style: none;
      li {
        margin: 0 1px 0 0;
        padding: 0;
        font-size: 0;
        width: 33.333%;
        float: left;
        width: calc(100% / 3);
        cursor: pointer;
      }
      li:last-child {
        margin: 0;
      }
    }
    .photo-small {
      position: relative;
      width: 100%;
      height: 32px;
      margin-left: -50%;
      margin-right: -50%;
      left: 50%;
      right: 50%;
      display: flex;
      overflow: hidden;
      background-color: var(--gray100);
      img {
        width: 100%;
        text-align: center;
        background-position: 100%;
        background-size: cover;
        height: 100%;
        object-fit: cover;
      }
    }
    .photo-cover {
      position: absolute;
      z-index: 100;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      text-align: center;
      width: 100%;
      height: inherit;
      &:hover {
        background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 0, rgba(0, 0, 0, 0.3) 95%, rgba(0, 0, 0, 0.3));
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        transition: all .2s ease-out;
      }
      &.black_cover {
        background: rgba(0, 0, 0, 0.8);
        text-align: center;
        font-size: 0.75rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .photo_more {
        color: var(--gray0);
      }
    }
  }
`;

export default YadoItemPhotoView;
